import axiosInstance from './api.config';

export const libraryAPI = {
  // Книги
  getBooks: (params = {}) => axiosInstance.get('/library/books/', { params }),
  getBookBySlug: (slug) => axiosInstance.get(`/library/books/${slug}/`),
  getFeatured: () => axiosInstance.get('/library/books/featured/'),
  getPopular: () => axiosInstance.get('/library/books/popular/'),
  downloadBook: (slug) => axiosInstance.get(`/library/books/${slug}/download/`),
  
  // Категории
  getCategories: () => axiosInstance.get('/library/categories/'),
  getCategoryBySlug: (slug) => axiosInstance.get(`/library/categories/${slug}/`),
  createCategory: (data) => axiosInstance.post('/library/categories/', data),
  updateCategory: (slug, data) => axiosInstance.put(`/library/categories/${slug}/`, data),
  deleteCategory: (slug) => axiosInstance.delete(`/library/categories/${slug}/`),
  
  // Авторы
  getAuthors: (params = {}) => axiosInstance.get('/library/authors/', { params }),
  getAuthorById: (id) => axiosInstance.get(`/library/authors/${id}/`),
  getAuthorBooks: (id) => axiosInstance.get(`/library/authors/${id}/books/`),
  createAuthor: (data) => axiosInstance.post('/library/authors/', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  updateAuthor: (id, data) => axiosInstance.put(`/library/authors/${id}/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteAuthor: (id) => axiosInstance.delete(`/library/authors/${id}/`),
  
  // Отзывы
  getReviews: (slug) => axiosInstance.get(`/library/books/${slug}/reviews/`),
  createReview: (data) => axiosInstance.post('/library/reviews/', data),
  updateReview: (id, data) => axiosInstance.put(`/library/reviews/${id}/`, data),
  deleteReview: (id) => axiosInstance.delete(`/library/reviews/${id}/`),
  
  // Список чтения
  getReadingList: (params = {}) => axiosInstance.get('/library/reading-list/', { params }),
  addToReadingList: (data) => axiosInstance.post('/library/reading-list/', data),
  updateReadingStatus: (id, status) => axiosInstance.patch(`/library/reading-list/${id}/`, { status }),
  removeFromReadingList: (id) => axiosInstance.delete(`/library/reading-list/${id}/`),
  getReadingStats: () => axiosInstance.get('/library/reading-list/stats/'),
  
  // Админ функции
  createBook: (data) => axiosInstance.post('/library/books/', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  updateBook: (slug, data) => axiosInstance.put(`/library/books/${slug}/`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  deleteBook: (slug) => axiosInstance.delete(`/library/books/${slug}/`),
};
